import React from "react";
import { useMediaQuery } from "@mantine/hooks";

export default function VerificationIframe({
  opened,
  onClose,
  verificationLink,
  title = "Verification",
}) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  if (!opened || !verificationLink) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        overflow: "hidden",
      }}
    >
      <iframe
        src={verificationLink}
        title={title}
        allow="camera; clipboard-write; publickey-credentials-create; publickey-credentials-get"
        allowFullScreen
        style={{
          width: isMobile ? "100vw" : "420px",
          // Use dynamic viewport height (dvh) on mobile so the frame fits the
          // visible area excluding browser chrome — 100vh overflows and scrolls.
          height: isMobile ? "100dvh" : "670px",
          maxWidth: "100vw",
          maxHeight: isMobile ? "100dvh" : "100vh",
          border: "none",
          display: "block",
          borderRadius: isMobile ? 0 : "12px",
        }}
      />
    </div>
  );
}
